<template lang="pug">
div
  ein-decision-modal(
    v-if="step == steps.DECISION"
    :open-dialog="showRegistrationFlowModal"
    @close="onCloseEinDecisionModal"
    @soft-close="onSoftClose"
    @show-registration-brand-modal="onShowRegisterSoleProprietorModal"
    :isIncompleteReg="false"
  )
  register-sole-proprietor-modal(
    v-if="step == steps.SOLE_PROPRIETOR || step == steps.CAMPAIGN"
    :value="showRegistrationFlowModal"
    @close="onCloseRegisterModal"
    @show-register-fee-modal="onShowRegisterFeeModal"
  )
  register-fee-modal(
    v-if="step == steps.PAYMENT"
    v-model="showRegistrationFlowModal"
    @complete="onCompleteRegisterFeeModal"
    @close="onCloseRegisterFeeModal"
    @skip="onSkipRegisterFeeModal"
  )
  leads-plus-unregistered-modal(
    v-if="shouldGoToLeadsPlusFlow && step == steps.STATUS && isLeadsPlusUser === true"
    :open-dialog="showRegistrationFlowModal"
    @close="onCloseRegisterStatusModal"
    @soft-close="onSoftClose"
  )
  registration-status-modal(
    v-else-if="step == steps.STATUS"
    :open-dialog="showRegistrationFlowModal"
    @close="onCloseRegisterStatusModal"
    @soft-close="onSoftClose"
  )
  
</template>

  
<script>
import { STEPS_SOLE_PROPRIETOR } from '@/a2p/config';
import { mapState, mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/event-bus';

import EinDecisionModal from '@/Core/components/EinDecisionModal';
import RegisterFeeModal from '@/Core/components/RegisterFeeModal';
import RegisterSoleProprietorModal from '@/Core/components/RegisterSoleProprietorModal';
import RegistrationStatusModal from '@/Core/components/RegistrationStatusModal';
import LeadsPlusUnregisteredModal from '@/Core/components/LeadsPlusUnregisteredModal';


export default {
  name: 'SolePropFlowModal',
  components: {
    EinDecisionModal,
    RegisterFeeModal,
    RegisterSoleProprietorModal,
    RegistrationStatusModal,
    LeadsPlusUnregisteredModal,
  },
  props: {
    openDialog: false,
  },
  data() {
    return {
      steps: STEPS_SOLE_PROPRIETOR,
    };
  },
  methods: {
    ...mapActions('registerSoleProprietorA2p', ['setShowRegistrationFlowModal', 'setStep']),
    onCloseEinDecisionModal() {
      EventBus.$emit('sole-prop-modal-close', this.registrationModalClose);
      this.setShowRegistrationFlowModal({ bool: false });
    },
    onCloseRegisterFeeModal() {
      EventBus.$emit('sole-prop-modal-close', this.registrationModalClose);
      this.setShowRegistrationFlowModal({ bool: false });
    },
    onCloseRegisterStatusModal() {
      EventBus.$emit('sole-prop-modal-close', this.registrationModalClose);
      this.setShowRegistrationFlowModal({ bool: false });
    },
    onCloseRegisterModal() {
      EventBus.$emit('sole-prop-modal-close', this.registrationModalClose);
      this.setShowRegistrationFlowModal({ bool: false });
    },
    onSoftClose() {
      this.setShowRegistrationFlowModal({ bool: false });
    },
    onShowRegisterSoleProprietorModal() {
      this.setStep(this.steps.SOLE_PROPRIETOR);
    },
    onShowRegisterFeeModal() {
      this.setStep(this.steps.PAYMENT);
    },
    onCompleteRegisterFeeModal() {
      this.setStep(this.steps.STATUS);
    },
    onSkipRegisterFeeModal() {
      this.setStep(this.steps.STATUS);
    },
  },
  computed: {
    ...mapState('registerSoleProprietorA2p', ['step', 'showRegistrationFlowModal', 'registrationModalClose']),
    ...mapState('conversations', ['isLeadsPlusUser']),
    ...mapGetters('userInformation', ['shouldGoToLeadsPlusFlow']),
  },
};
</script>
